import { useEffect } from 'react'

const INN = '166014711920'
const EMAIL = 'hello@mybst.ru'
const SITE = 'mybst.ru'

export function PrivacyPage() {
  useEffect(() => {
    document.documentElement.classList.remove('dark')
    document.body.style.overflow = 'auto'
    document.body.style.height = 'auto'
    document.title = 'Политика конфиденциальности — BST'
    return () => {
      document.body.style.overflow = ''
      document.body.style.height = ''
    }
  }, [])

  const section = (title: string, children: React.ReactNode) => (
    <section style={{ marginBottom: '32px' }}>
      <h2 style={{ fontSize: '16px', fontWeight: 700, color: '#1a1a1a', margin: '0 0 12px', borderBottom: '1px solid #e0e0e0', paddingBottom: '8px' }}>
        {title}
      </h2>
      <div style={{ fontSize: '14px', color: '#444', lineHeight: 1.8 }}>
        {children}
      </div>
    </section>
  )

  return (
    <div style={{
      minHeight: '100vh',
      background: '#f5f5f5',
      fontFamily: "'Inter', 'Segoe UI', system-ui, sans-serif",
    }}>
      {/* Header */}
      <header style={{
        background: '#fff',
        borderBottom: '1px solid #e0e0e0',
        padding: '16px 24px',
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
      }}>
        <a href="/" style={{ display: 'flex', alignItems: 'center', gap: '8px', textDecoration: 'none' }}>
          <div style={{
            width: '32px', height: '32px', borderRadius: '8px',
            background: '#5b6af0',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontWeight: 900, color: '#fff', fontSize: '14px',
          }}>B</div>
          <span style={{ fontWeight: 900, fontSize: '20px', color: '#1a1a1a', letterSpacing: '-0.5px' }}>BST</span>
        </a>
        <span style={{ color: '#9b9b9b', fontSize: '13px', marginLeft: '4px' }}>/ Политика конфиденциальности</span>
      </header>

      <main style={{ maxWidth: '780px', margin: '0 auto', padding: '40px 24px 60px' }}>
        <h1 style={{ fontSize: '26px', fontWeight: 900, color: '#1a1a1a', margin: '0 0 6px', letterSpacing: '-0.5px' }}>
          Политика конфиденциальности
        </h1>
        <p style={{ fontSize: '13px', color: '#9b9b9b', margin: '0 0 36px' }}>
          Редакция от 29 сентября 2026 г. · Соответствует 152-ФЗ «О персональных данных»
        </p>

        {section('1. Общие положения', <>
          <p>1.1. Настоящая Политика конфиденциальности определяет порядок обработки и защиты персональных данных Пользователей сервиса BST ({SITE}), осуществляемой физическим лицом Ивановым Олегом Андреевичем, действующим в статусе самозанятого на основании Федерального закона от 27.11.2018 № 422-ФЗ (далее — «Оператор»).</p>
          <p>1.2. Политика разработана в соответствии с требованиями Федерального закона от 27.07.2006 № 152-ФЗ «О персональных данных».</p>
          <p>1.3. Использование Сервиса означает безоговорочное согласие Пользователя с настоящей Политикой и указанными в ней условиями обработки его персональных данных.</p>
        </>)}

        {section('2. Состав персональных данных', <>
          <p>2.1. В рамках работы Сервиса Оператор может обрабатывать следующие персональные данные:</p>
          <ul style={{ paddingLeft: '20px', margin: '4px 0 12px' }}>
            <li><strong>Данные, предоставляемые при регистрации:</strong> адрес электронной почты, имя, пароль (в виде хэша).</li>
            <li><strong>Данные OAuth-входа:</strong> идентификатор аккаунта Google или GitHub, имя профиля, адрес электронной почты, аватар.</li>
            <li><strong>Платёжные данные:</strong> обрабатываются платёжной системой ЮКасса; Оператор не хранит данные банковских карт.</li>
            <li><strong>Технические данные:</strong> IP-адрес, тип браузера (User-Agent), страницы посещений, данные cookie/localStorage.</li>
            <li><strong>Данные сайтов:</strong> контент, созданный Пользователем с помощью конструктора, включая текст, изображения и загруженные файлы.</li>
            <li><strong>AI-запросы:</strong> текст промпта Пользователя и результат его обработки AI-провайдером (см. §5.4).</li>
            <li><strong>Данные согласий:</strong> факт и время принятия оферты/Политики, факт и время предоставления/отзыва маркетингового согласия, IP-адрес и User-Agent на момент события — для доказывания согласия по ст. 9 152-ФЗ.</li>
          </ul>
        </>)}

        {section('3. Цели обработки персональных данных', <>
          <p>3.1. Персональные данные обрабатываются в следующих целях:</p>
          <ul style={{ paddingLeft: '20px', margin: '4px 0 12px' }}>
            <li>предоставление доступа к Сервису и его функциям;</li>
            <li>идентификация и аутентификация Пользователя;</li>
            <li>обработка платежей и управление подписками;</li>
            <li>направление уведомлений, связанных с работой Сервиса (верификация email, оплата);</li>
            <li>направление маркетинговых сообщений — только при наличии явного согласия Пользователя;</li>
            <li>улучшение качества Сервиса и техническая поддержка;</li>
            <li>исполнение требований законодательства РФ.</li>
          </ul>
        </>)}

        {section('4. Правовые основания обработки', <>
          <p>4.1. Обработка персональных данных осуществляется на следующих правовых основаниях:</p>
          <ul style={{ paddingLeft: '20px', margin: '4px 0 12px' }}>
            <li>исполнение договора (оферты), стороной которого является Пользователь (ст. 6 ч.1 п.5 152-ФЗ);</li>
            <li>согласие Пользователя — для маркетинговых рассылок (ст. 9 152-ФЗ);</li>
            <li>исполнение требований законодательства РФ.</li>
          </ul>
        </>)}

        {section('5. Передача данных третьим лицам', <>
          <p>5.1. Персональные данные Пользователей могут быть переданы следующим третьим лицам исключительно в рамках оказания услуг:</p>
          <ul style={{ paddingLeft: '20px', margin: '4px 0 12px' }}>
            <li><strong>Resend Inc.</strong> (США) или SMTP-провайдер — для отправки email-уведомлений (адрес электронной почты + текст письма);</li>
            <li><strong>ЮКасса</strong> (Российская Федерация) — для обработки платежей (внутренний идентификатор Пользователя, сумма, тарифный план);</li>
            <li><strong>Google LLC</strong> (США) — при использовании OAuth-входа через Google (обмен email/имени/аватара);</li>
            <li><strong>GitHub Inc.</strong> (США) — при использовании OAuth-входа через GitHub (обмен email/username/аватара);</li>
            <li><strong>Серверная инфраструктура</strong> — российский хостинг, где физически размещены базы данных и загруженные файлы.</li>
          </ul>

          <p>5.2. Оператор не продаёт и не передаёт персональные данные Пользователей третьим лицам в маркетинговых целях.</p>
          <p>5.3. Передача данных возможна по требованию уполномоченных государственных органов в случаях, предусмотренных законодательством РФ.</p>

          <p>5.4. <strong>AI-провайдеры.</strong> При использовании функций генерации сайта или блоков Пользователем текст введённого им промпта и метаданные проекта передаются для обработки в следующие сервисы:</p>
          <ul style={{ paddingLeft: '20px', margin: '4px 0 12px' }}>
            <li><strong>Anthropic, PBC</strong> (США) — основной AI-провайдер (модель Claude). Оператор не передаёт AI-провайдеру email, имя или внутренний идентификатор Пользователя;</li>
            <li><strong>DeepSeek Inc.</strong> (Китайская Народная Республика) — резервный AI-провайдер (используется только при недоступности основного);</li>
            <li><strong>Pexels</strong> (США), <strong>Unsplash</strong> (США) — при поиске изображений для сгенерированного сайта передаётся поисковой запрос, сгенерированный на основе промпта; email/имя Пользователя не передаются.</li>
          </ul>
          <p>5.5. Пользователь должен воздерживаться от ввода в промпт паролей, платёжных данных, а также персональных данных третьих лиц без наличия соответствующего правового основания (см. также §16 оферты).</p>
        </>)}

        {section('6. Хранение, локализация и защита данных', <>
          <p>6.1. Первичный сбор и хранение персональных данных Пользователей осуществляются на территории Российской Федерации (ч. 5 ст. 18 152-ФЗ): база данных PostgreSQL, кэш Redis и загруженные файлы размещаются на серверах в России.</p>
          <p>6.2. Оператор применяет организационные и технические меры защиты: шифрование паролей (bcrypt, cost=12), обязательное HTTPS с TLS не ниже 1.2, ограниченный доступ к базам данных, разграничение прав, ротация access/refresh-токенов.</p>
          <p>6.3. Сроки хранения:</p>
          <ul style={{ paddingLeft: '20px', margin: '4px 0 12px' }}>
            <li>основные данные аккаунта — до момента удаления аккаунта Пользователем или по его запросу;</li>
            <li>коды подтверждения email — не более 24 часов с момента выдачи;</li>
            <li>refresh-токены сессий — до истечения срока действия (не более 30 дней);</li>
            <li>служебные записи безопасности (audit-логи) — до 1 года;</li>
            <li>логи AI-запросов (промпты и результаты) — до 180 дней с момента создания;</li>
            <li>записи о факте согласия и его отзыве — в течение срока обработки соответствующих данных;</li>
            <li>иные сведения — в течение сроков, установленных законодательством РФ.</li>
          </ul>
          <p>6.4. <strong>Трансграничная передача.</strong> Оператор осуществляет трансграничную передачу отдельных категорий персональных данных в следующие юрисдикции: США (Anthropic, Resend, Google, GitHub, Pexels, Unsplash), Китайская Народная Республика (DeepSeek — при недоступности основного AI-провайдера). Передача осуществляется в целях исполнения договора об оказании услуг Пользователю (ст. 6 ч.1 п.5 152-ФЗ) и с учётом требований ст. 12 152-ФЗ. Пользователь, принимая настоящую Политику и оферту, подтверждает информированность о такой передаче.</p>
        </>)}

        {section('7. Права субъектов персональных данных', <>
          <p>7.1. Пользователь вправе:</p>
          <ul style={{ paddingLeft: '20px', margin: '4px 0 12px' }}>
            <li>получить информацию об обрабатываемых персональных данных;</li>
            <li>требовать уточнения, блокирования или уничтожения персональных данных;</li>
            <li>отозвать согласие на обработку данных (маркетинговое согласие отзывается в разделе «Настройки → Маркетинговые уведомления»);</li>
            <li>самостоятельно удалить аккаунт через раздел «Настройки → Опасная зона», при этом удаляются: учётные данные, все сайты, страницы, медиа-файлы, сохранённые блоки, API-ключи, логи AI-запросов; служебные логи безопасности — деперсонифицируются.</li>
          </ul>
          <p>7.2. Для запросов, которые не могут быть выполнены через личный кабинет, обращайтесь по адресу: <a href={`mailto:${EMAIL}`} style={{ color: '#5b6af0' }}>{EMAIL}</a>. Запрос будет рассмотрен в течение 30 дней.</p>
          <p>7.3. Если Пользователь считает, что его права нарушены при обработке персональных данных Оператором, он вправе обратиться в Роскомнадзор (rkn.gov.ru) или в суд.</p>
        </>)}

        {section('8. Cookie', <>
          <p>8.1. Сервис использует файлы cookie. Подробная информация о составе и целях использования cookie содержится в <a href="/cookies" style={{ color: '#5b6af0' }}>Политике использования cookie</a>.</p>
        </>)}

        {section('9. Изменение политики', <>
          <p>9.1. Оператор вправе вносить изменения в настоящую Политику. Новая редакция вступает в силу с момента её публикации, если иное не предусмотрено новой редакцией.</p>
          <p>9.2. О существенных изменениях Пользователь будет уведомлён по email.</p>
        </>)}

        {section('10. Контакты оператора', <>
          <p>Иванов Олег Андреевич</p>
          <p>Статус: самозанятый (НПД, Закон № 422-ФЗ)</p>
          <p>ИНН: {INN}</p>
          <p>Email: <a href={`mailto:${EMAIL}`} style={{ color: '#5b6af0' }}>{EMAIL}</a></p>
        </>)}
      </main>

      <footer style={{
        background: '#fff', borderTop: '1px solid #e0e0e0',
        padding: '20px 24px', textAlign: 'center',
        fontSize: '13px', color: '#9b9b9b',
        display: 'flex', gap: '16px', justifyContent: 'center', flexWrap: 'wrap',
      }}>
        <a href="/terms" style={{ color: '#9b9b9b', textDecoration: 'none' }}>Оферта</a>
        <a href="/privacy" style={{ color: '#9b9b9b', textDecoration: 'none' }}>Конфиденциальность</a>
        <a href="/cookies" style={{ color: '#9b9b9b', textDecoration: 'none' }}>Cookie</a>
        <span>© {new Date().getFullYear()} BST</span>
      </footer>
    </div>
  )
}
